var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', _vm._g({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "19",
      "height": "19"
    }
  }, _vm.$listeners), [_c('g', {
    attrs: {
      "fill-rule": "evenodd"
    }
  }, [_c('path', {
    attrs: {
      "d": "M2.28 16.325h2.062v-2.062H2.281zM8.753 1.78H9.85V0H8.753zM0 8.827v1.097h8.753v2.784H9.85V8.827zM0 6.62h6.62V0H0zm1.098-1.097h4.424V1.098H1.098zM8.754 6.62H9.85V2.945H8.754z"
    }
  }), _c('path', {
    attrs: {
      "d": "M2.28 4.34h2.06V2.28H2.28zm10.688 4.413h-1.097v6.085H8.233v1.097h4.735zM0 18.603h6.62v-6.62H0zm1.098-1.097h4.424v-4.425H1.098zm16.407-7.202h1.098v-1.55h-1.098zM14.263 4.34h2.061V2.28h-2.061z"
    }
  }), _c('path', {
    attrs: {
      "d": "M11.984 6.62h6.62V0h-6.62zm1.099-1.097h4.424V1.098h-4.424zm-2.477 13.08h2.363v-1.097h-2.363zm4.238-2.668h1.098V8.753h-1.098z"
    }
  }), _c('path', {
    attrs: {
      "d": "M17.505 13.13v4.375h-2.852v1.099h3.95v-5.475z"
    }
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }